import React, { useMemo } from 'react'
import { createColumnHelper, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { Table } from '../../OrderDetails/components/Table'
import { useOrderGroupDetailContext } from '../context/OrderGroupDetailContext'
import { formatDate } from '../../../lib/Util'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { graphql, useFragment } from '../../../gql'
import { formatPrice } from '../../../components/OrderPrice'
import { getStateForOrderIndex } from '../hooks/useSubmitAllOrders'
import { OrderProgressStatus, OrderStatusIndicator } from './OrderStatusIndicator'
import { Order } from '../../../components'

export const GroupOrders_OrderGroupFragment = graphql(`
  fragment GroupOrders_OrderGroup on OrderGroup {
    id
    orders {
      id
      reservationNumber
      clearanceItems {
        id
      }
      carrier {
        id
        name
      }
      ...OrderListItem_Order
    }
  }
`)

export const GroupOrders: React.FC<{
  currentProgress: SubmitGroupProgress | null
  sortOrders: (orders: Order[]) => Order[]
  processStatus: ProcessStates
  errorsByOrderId: Record<Order['id'], string[]>
}> = ({ currentProgress, sortOrders, processStatus, errorsByOrderId }) => {
  const { orderGroup } = useOrderGroupDetailContext()
  const group = useFragment(GroupOrders_OrderGroupFragment, orderGroup)

  const orders = useMemo(() => {
    if (!group?.orders) return []

    return sortOrders(group.orders).map((order, index) => ({
      order,
      progress:
        order.processStatus?.id === processStatus
          ? getStateForOrderIndex(currentProgress, index, order.id)
          : 'excluded',
    }))
  }, [group, currentProgress])

  return (
    <div className="h-full flex flex-col">
      <h2 className="text-lg font-semibold mb-4">Objednávky ({orders.length})</h2>
      <div className={'grid gap-4 orderColumns'}>
        {orders.map(o => (
          <div key={o.order.id}>
            <Order order={o.order} key={o.order.id} progress={o.progress} isUpdating={false} groupId={group.id} />
            {errorsByOrderId[o.order.id] && (
              <div className="bg-red p-2 rounded-md mt-4 text-white text-sm shadow-md border border-gray-200">
                Stala se chyba při zpracování objednávky {o.order.reservationNumber}:{' '}
                <span className="font-bold">{errorsByOrderId[o.order.id]}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
